/**
 * Tracking constants for the audit-insights feature.
 *
 * Uses INTERACTION_TYPES from shared/observability for the event `type`.
 * Defines insights-specific page identifiers and action names.
 */

/** Page identifiers for the insights surface. */
export const AUDIT_INSIGHTS_PAGES = {
  tab: 'audit-insights-tab',
} as const;

/**
 * Action names used in `type: 'action_triggered'` events.
 *
 * The two panels are named separately rather than sharing one `openPanel` action, so the
 * split between readers who follow up on recurrence and readers who follow up on
 * outstanding work is measurable.
 */
export const AUDIT_INSIGHTS_ACTIONS = {
  openRecurringPanel: 'open_recurring_panel',
  openOpenTasksPanel: 'open_open_tasks_panel',
  closePanel: 'close_panel',
  /**
   * Opening one row's detail. Split from the panel actions because opening a panel is
   * scanning and opening a row is following up on a specific question or action.
   */
  openRecurringDetail: 'open_recurring_detail',
  openOpenTaskDetail: 'open_open_task_detail',
  closeDetail: 'close_detail',
} as const;
